import axios from "axios";

// Build-time backend URL. May be set to the preview origin, the production origin, or empty.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Resolve the right baseURL at runtime.
//
// If the bundle was built against a DIFFERENT origin than where it's currently being served
// (e.g. preview-built bundle deployed to agentreply.io), absolute-URL calls would trigger
// CORS preflights and fail. Both preview (K8s ingress) and production (agentreply.io) serve
// /api/* at the same origin as the frontend, so falling back to a same-origin "/api" path
// makes the app deploy-portable across environments.
function _resolveBaseURL() {
  if (typeof window === "undefined") {
    // SSR / build-time — use whatever the env says.
    return ENV_BACKEND_URL ? `${ENV_BACKEND_URL}/api` : "/api";
  }
  if (!ENV_BACKEND_URL) return "/api";
  try {
    const envHost = new URL(ENV_BACKEND_URL).hostname;
    if (envHost && envHost !== window.location.hostname) {
      // Built-for-A, served-from-B → use same-origin
      return "/api";
    }
  } catch {
    return "/api";
  }
  return `${ENV_BACKEND_URL}/api`;
}

export const API = _resolveBaseURL();

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
